import script from "./SubsidiaryRiskLevelPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubsidiaryRiskLevelPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SubsidiaryRiskLevelPanel.vue?vue&type=style&index=0&id=90a115f8&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a115f8"]])

export default __exports__